import styled from "styled-components";
import {
  FilledInput,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { offerPositionUpdate } from "../../../../../services/offers/update-offer-position";
import { toast } from "react-toastify";
import { settings } from "../../../../../helpers/toast.settings";
import { useFormik } from "formik";
import { PricelistOffersGetByIdItems } from "../../../../../services/orders/pricelist-offers-get-by-id/types";
import { StyledButton } from "../../../../../components/Button/button";
import { OffersPositionItem } from "../../../../../services/offers/get-all-offers-position/types";
import { OffersItem } from "../../../../../services/offers/get-all-offers/types";
import { offerUpdate } from "../../../../../services/offers/update-offer";
import { theme } from "../../../../../helpers/theme";
import { Input } from "../../../../../components/Input/input";
import { OfferStatusesArray, OfferTypesArray } from "./helpers";
interface OfferingOfferEditFormProps {
  offer: OffersItem;
}
const OfferingOfferEditForm = ({ offer }: OfferingOfferEditFormProps) => {
  const EditOfferMutation = useMutation(offerUpdate, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", {
        toastId: "EditSuccessfully",
        ...settings,
      });
    },
  });
  const formik = useFormik({
    initialValues: {
      status_oferty: offer.status_oferty,
      notatka_konsultanta: offer.notatkaKonsultanta,
      rodzaj_oferty: offer.rodzaj_oferty,
    },
    // validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_oferty: offer.id_oferty,
        data_wprowadzenia: offer.data_wprowadzenia,
        rodzaj_oferty: formik.values.rodzaj_oferty,
        status_oferty: formik.values.status_oferty,
        notatka_konsultanta: formik.values.notatka_konsultanta,
        data_waznosci_token: null,
        id_zamowienia: offer.id_zamowienia,
      };

      EditOfferMutation.mutate(body);
    },
  });
  return (
    <FormWrapper onSubmit={formik.handleSubmit}>
      <FormControl fullWidth>
        <InputLabel id="rodzaj_oferty-label">Rodzaj oferty</InputLabel>
        <Select
          placeholder="rodzaj_oferty"
          labelId="rodzaj_oferty-label"
          label="rodzaj_oferty"
          id="rodzaj_oferty"
          name="rodzaj_oferty"
          value={formik.values.rodzaj_oferty}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          style={{ backgroundColor: "white" }}
        >
          {OfferTypesArray.map((item, index) => (
            <MenuItem value={index}>{item}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth>
        <InputLabel id="status_oferty-label">Status oferty</InputLabel>
        <Select
          placeholder="status_oferty"
          labelId="status_oferty-label"
          label="status_oferty"
          id="status_oferty"
          name="status_oferty"
          value={formik.values.status_oferty}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          style={{ backgroundColor: "white" }}
        >
          {OfferStatusesArray.map((item, index) => (
            <MenuItem value={index}>{item}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <Input
        label="Nazwa"
        id="notatka_konsultanta"
        name="notatka_konsultanta"
        value={formik.values.notatka_konsultanta}
        onChange={formik.handleChange}
        error={
          formik.touched.notatka_konsultanta &&
          Boolean(formik.errors.notatka_konsultanta)
        }
        helperText={
          formik.touched.notatka_konsultanta &&
          formik.errors.notatka_konsultanta
        }
        onBlur={formik.handleBlur}
        variant="filled"
      />

      <StyledButton
        disabled={EditOfferMutation.isLoading}
        type="submit"
        variant="contained"
      >
        Zapisz
      </StyledButton>
    </FormWrapper>
  );
};

export default OfferingOfferEditForm;

const FormWrapper = styled.form`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 420px;
  gap: 25px;

  @media (${theme.device.laptop}) {
    width: 100%;
  }
`;
